import { Component } from '@theme/component';

/**
 * A web component that collapses table rows beyond a visible limit.
 * Rows are hidden via CSS using :nth-child and a [data-expanded] attribute toggle.
 * When data-visible-rows is not set, acts as a plain container (no collapsing).
 *
 * @typedef {object} TableCollapseRefs
 * @property {HTMLTableElement} table - The table element.
 * @property {HTMLButtonElement} [toggle] - The toggle button (only present when collapsible).
 * @extends Component<TableCollapseRefs>
 */
class TableCollapseComponent extends Component {
  requiredRefs = ['table'];

  /**
   * Toggles between expanded and collapsed states.
   */
  handleToggle() {
    const isExpanded = this.hasAttribute('data-expanded');

    if (isExpanded) {
      this.removeAttribute('data-expanded');
    } else {
      this.setAttribute('data-expanded', '');
    }

    const { toggle } = this.refs;
    if (!toggle) return;

    toggle.textContent = isExpanded ? this.dataset.showMoreText : this.dataset.showLessText;
    toggle.setAttribute('aria-expanded', String(!isExpanded));
  }
}

if (!customElements.get('table-collapse')) {
  customElements.define('table-collapse', TableCollapseComponent);
}
